import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import { BMapLoader } from '@/utils/bdMap.js';
import { ElMessage, ElMessageBox, ElNotification } from 'element-plus';
import { sizeFilter, handleHttp, transformStr3, getformListItemsdatas, getFileStatus, formatToLine, getImg } from "@/utils/utils";
import { isHasLinkHandle, navigationUrl, getlastclickmarker, getStr } from '@/view/map/js/common';
export default {
  // standardappmap
  name: 'sdImap',
  meta: {
    title: '地图'
  },
  data() {
    return {
      currentSwitch: false,
      isMobile: 0,
      map: null,
      activeName: '0',
      activeIndex: 0,
      tabsData: [],
      formparams: {
        deptId: '',
        formId: 349949,
        page: 1,
        limit: 100,
        searchStr: '',
        orderBy: 'manualOrderTop,manualOrder'
      },
      loading: true,
      dataparams: {
        deptId: '',
        formId: '',
        page: 1,
        limit: 100,
        searchStr: ''
      },
      dataList: [],
      datatotal: 0,
      currentlinkparam: '',
      currentlistparams: [],
      currentdetailparams: [],
      currentlocationparam: '',
      crrrentstructData: [],
      currenIndex: 0,
      infoDetail: {},
      otherinfo: [],
      currendata: {},
      isHasNav: '',
      infoDetailflag: false,
      initialswitch: true,
      currentSwitch: false,
      condition: {
        model: 0,
        filters: []
      },
      indexstyle: 2,
      index2image: 'https://p.ananas.chaoxing.com/star3/origin/1e27ad6ff860a656c37c49da3fd3c53a.png'
    };
  },
  mounted() {
    document.querySelector('html').style.height = '100%';
    document.querySelector('#app').style.height = '100%';
    document.querySelector('body').setAttribute('style', 'background: none!important; height: 100%');
    //   this.getAMap()
    this.getTabsData();
    this.isMobile = document.body.clientWidth < 768;
    this.currentSwitch = !this.isMobile;
    this.onresize();
  },
  watch: {
    infoDetail(val) {
      if (val) {
        // console.log(val)
        if (JSON.stringify(val) === '{}') {
          ELEMENT.Message.error('无定位点或暂无链接');
          return;
        }
        this.otherinfo = val.filter((item, index) => {
          return index > 1 && item !== '';
        });
      }
    }
  },
  methods: {
    // 获取tabs数据
    getTabsData() {
      let that = this;
      this.formparams.deptId = this.$route.query.fid;
      this.$api.singleadvanceSearch(this.formparams).then(res => {
        let formData = [];
        let titleArr = [];
        that.loading = false;
        if (res.totalRow > 0) {
          formData = res.dataList.map((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            item.itemformdata = itemformat;
            item.itemformdata.index = index.toString();
            if (itemformat.typeparams !== '') {
              let typeArr = itemformat.typeparams.split(',');
              let typeData = [];
              typeArr.forEach((types, typesindex) => {
                let type = types.split('|');
                //console.log(type)
                typeData.push({
                  title: type[0],
                  param: type[1],
                  options: [],
                  index: ''
                });
              });

              // 获取对应表单字段结构
              let params = {
                deptId: itemformat.unitfid,
                formId: itemformat.unitformId
              };
              this.$api.formStruct(params).then(res => {
                if (res.length > 0) {
                  that.crrrentstructData = res;
                  //console.log(typeData)
                  typeData.forEach(typeitem => {
                    //console.log(typeitem.param)
                    res.forEach(stuctitem => {
                      if (typeitem.param === stuctitem.alias) {
                        // console.log(stuctitem)
                        typeitem.options = stuctitem.field.options;
                      }
                    });
                  });
                  item.itemformdata.typeData = typeData;
                }
              });
            }
            // console.log(item.itemformdata)
            //   if (item.itemformdata.showIndex !== '' && parseInt(item.itemformdata.showIndex) === 1) {
            //       that.tabsData.push(item.itemformdata)
            //   }
            that.tabsData.push(item.itemformdata);
            titleArr.push(itemformat.title);
            return item;
          });
          //   console.log(that.tabsData)
          that.activeName = that.tabsData[0].title;
          if (that.tabsData[0].selectcondition !== undefined && that.tabsData[0].selectcondition !== '') {
            let selectcondition = JSON.parse(that.tabsData[0].selectcondition);
            // console.log(selectcondition)
            let confilters = [];
            selectcondition.forEach(items => {
              if (items.compt === 'selectbox' || items.compt === 'radiobutton') {
                items.val = [items.val];
              }
              confilters.push([items]);
            });
            that.condition.filters = confilters;
            that.dataparams.searchStr = selectcondition !== '[]' ? encodeURI(JSON.stringify(that.condition)) : '';
          }

          // 通用地图基础配置 是否存在数据
          if (that.tabsData[0][44] && that.tabsData[0][44] !== '') {
            // that.isHasTitle = true
            // that.basicformUserId = that.tabsData[0].form[44]
            let form = {
              deptId: this.$route.query.fid,
              formId: 677917,
              limit: 20,
              searchStr: ''
            };
            this.$api.singleadvanceSearch(form).then(res => {
              res.dataList.map(elem => {
                let itemformdata = elem.formIdValueData;
                let itemformat = {};
                Object.keys(itemformdata).forEach(key => {
                  itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
                });
                elem.itemformdata = itemformat;
                if (elem.id === Number(that.tabsData[0][44])) {
                  // console.log(elem.itemformdata)
                  // 网页标题
                  if (elem.itemformdata.toptitle && elem.itemformdata.toptitle !== '') {
                    document.title = elem.itemformdata.toptitle;
                  }
                  // 搜索自定义
                  if (elem.itemformdata.searchtitle.length !== 0 && elem.itemformdata.searchtitle !== '') {
                    that.searchplaceholder = elem.itemformdata.searchtitle;
                  }
                  // 颜色自定义
                  if (elem.itemformdata.jsontxt) {
                    let jsontxt = JSON.parse(getStr(elem.itemformdata.jsontxt));
                    console.log(jsontxt);
                    let styleOptions = jsontxt.styleOption;
                    console.log(`styleOptions`, styleOptions);
                    document.documentElement.style.setProperty('--basic-maptheme', styleOptions.themecolor);
                    that.indexstyle = styleOptions.indexstyle === undefined ? 1 : styleOptions.indexstyle;
                    if (styleOptions.indexstyle2image !== undefined && styleOptions.indexstyle2image.length > 0) {
                      that.index2image = getImg(styleOptions.indexstyle2image[0]);
                    }
                  }
                  that.getAMap(that.tabsData[0]);
                }
                return elem;
              });
            });
          } else {
            that.getAMap(that.tabsData[0]);
          }
        }
      });
    },
    // 默认搜索字段
    defaultsearchparams(current) {
      // console.log(current)
      if (current === undefined) return;
      if (current.selectcondition !== undefined && current.selectcondition !== '') {
        let selectcondition = JSON.parse(current.selectcondition);
        // console.log(selectcondition)
        let confilters = [];
        let conditionstr = {
          model: 0,
          filters: []
        };
        selectcondition.forEach(items => {
          if (items.compt === 'selectbox' || items.compt === 'radiobutton') {
            items.val = [items.val];
          }
          confilters.push([items]);
        });
        conditionstr.filters = confilters;
        this.dataparams.searchStr = encodeURI(JSON.stringify(conditionstr));
      }
      this.dataparams.deptId = current.unitfid;
      this.dataparams.formId = current.unitformId;
      this.dataparams.mapSettingfid = current.unitfid;
      this.dataparams.page = 1;
      //   this.dataparams.limit = 100
      this.currentlistparams = current.listparams.split(',');
      this.currentdetailparams = current.detailparams.split(',');
      this.currentlocationparam = current.locationparam;
      this.currentlinkparam = current.linkparam;
      this.getList();
    },
    // 默认tabs列表数据
    getList() {
      let that = this;
      this.$api.map_search(this.dataparams).then(res => {
        let formData = [];
        that.loading = false;
        if (res.totalRow > 0) {
          formData = res.dataList.map((item, index) => {
            let itemformdata = item.formIdValueData;
            let itemformat = {};
            Object.keys(itemformdata).forEach(key => {
              itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
            });
            let sortindex = that.dataparams.limit * (that.dataparams.page - 1) + (index + 1);
            item.sortindex = sortindex;
            item.itemformdata = itemformat;
            let showparams = [];
            that.currentlistparams.forEach((items, indexs) => {
              let params = items.split('|');
              if (params.length > 1 && params[1].includes('_')) {
                params[1] = transformStr3(params[1]);
              }
              if (indexs === 0) {
                items !== '' ? showparams.push(item.itemformdata[params[1]].length === 0 ? '' : handleHttp('https://pan-yz.chaoxing.com/thumbnail/origin/' + item.itemformdata[params[1]][0].objectId)) : showparams.push('');
              } else {
                if (item.itemformdata[params[1]].length > 0 || typeof item.itemformdata[params[1]] === 'string' && item.itemformdata[params[1]] !== '') {
                  // 列表 第二个字段 标题 标红 处理
                  let paramsvalue = '';
                  // console.log(item.itemformdata[params[1]][0])
                  if (item.itemformdata[params[1]][0].address) {
                    paramsvalue = item.itemformdata[params[1]][0].address;
                  } else {
                    paramsvalue = typeof item.itemformdata[params[1]] === 'string' && item.itemformdata[params[1]] !== '' ? item.itemformdata[params[1]] : item.itemformdata[params[1]][0].val !== '' ? item.itemformdata[params[1]][0].val : '';
                  }
                  showparams.push('<span class="label">' + params[0] + '</span>' + paramsvalue);
                } else {
                  showparams.push('');
                }
              }
            });
            item.itemformdata.showparams = showparams;
            return item;
          });
          that.dataList = formData;
          that.datatotal = res.totalRow;
          if (that.currentlocationparam === '') {
            ElMessage({
              message: '当前表单未选择定位字段，不显示定位点',
              type: 'error'
            });
            that.map.clearOverlays();
            return;
          }
          that.createMarker();
        } else {
          that.dataList = [];
          that.datatotal = res.totalRow;
        }
      });
    },
    createMarker() {
      if (this.dataparams.page === 1) this.map.clearOverlays();
      let marker = null;
      let list = this.dataList;
      let bPoints = [];
      if (list.length > 0) {
        for (let i in list) {
          let point = list[i];
          for (let i in point.itemformdata) {
            let pointitem = point.itemformdata[i];
            if (pointitem.length > 0 && pointitem[0].lat) {
              let Bpoint = new window.BMapGL.Point(pointitem[0].lng, pointitem[0].lat);
              bPoints.push(Bpoint);
              // 创建文本标注
              marker = new window.BMapGL.Label('<span class="pointMarker">' + point.sortindex + '</span>', {
                position: Bpoint
              });
              marker.addEventListener('click', this.markerClickHandler);
              marker.sid = point.id;
              // console.log(Bmarker)
              this.map.addOverlay(marker);
            }
          }
        }
        let _this = this;
        setTimeout(function () {
          _this.setZoom(bPoints);
        }, 1000);
      }
    },
    setZoom(bPoints) {
      console.log(`bPoints`, eval(bPoints));
      let view = this.map.getViewport(eval(bPoints));
      console.log(`view`, view);
      let mapZoom = view.zoom;
      let centerPoint = view.center;
      console.log(`mapZoom`, mapZoom);
      console.log(`centerPoint`, centerPoint);
      this.map.centerAndZoom(centerPoint, mapZoom);
    },
    // 坐标点点击事件
    markerClickHandler(event) {
      console.log(event.target);
      this.fnInitSiteInfo(event.target);
    },
    fnInitSiteInfo(target) {
      this.infoDetail = {};
      for (let i in this.dataList) {
        if (this.dataList[i].id === target.sid) {
          let item = this.dataList[i];
          this.currendata = item;
          if (this.currentlocationparam !== '') {
            this.isHasNav = this.currendata.itemformdata[transformStr3(this.currentlocationparam)];
          }
          // console.log(item.itemformdata)
          let showparams = [];
          this.currentdetailparams.forEach((items, indexs) => {
            let params = items.split('|');
            // console.log(params)
            if (params.length > 1 && params[1].includes('_')) {
              params[1] = transformStr3(params[1]);
            }
            // console.log(item.itemformdata[params[1]])
            if (indexs === 0) {
              items !== '' ? showparams.push(handleHttp('https://pan-yz.chaoxing.com/thumbnail/origin/' + item.itemformdata[params[1]][0].objectId)) : showparams.push('');
            } else {
              // console.log(item.itemformdata[params[1]])
              // console.log(typeof(item.itemformdata[params[1]]))
              if (item.itemformdata[params[1]].length > 0 || typeof item.itemformdata[params[1]] === 'string' && item.itemformdata[params[1]] !== '') {
                if (typeof item.itemformdata[params[1]] !== 'string') {
                  let params1val = item.itemformdata[params[1]][0].address !== undefined ? item.itemformdata[params[1]][0].address : '';
                  item.itemformdata[params[1]] = params1val;
                }
                let paramsvalue = '';
                if (item.itemformdata[params[1]].length > 0 && item.itemformdata[params[1]][0].address) {
                  paramsvalue = item.itemformdata[params[1]][0].address;
                } else {
                  paramsvalue = item.itemformdata[params[1]];
                }
                showparams.push('<span class="label">' + params[0] + '</span>' + paramsvalue);
              } else {
                showparams.push('');
              }
            }
          });
          this.infoDetail = showparams;
          let infocontent = this.$refs.infoBox;
          this.map.setCenter(target.getPosition());
          let infoWindow = new BMapGL.InfoWindow(infocontent, {
            width: 300
          });
          this.map.openInfoWindow(infoWindow, target.getPosition());
          this.infoDetailflag = true;
        }
      }
    },
    listpoint(val) {
      // 是否有外链
      if (this.isMobile) {
        isHasLinkHandle(this.currentlinkparam, val);
        return;
      }
      let currentTarget = this.getLastClickMarker(val.id);
      if (currentTarget) {
        this.fnInitSiteInfo(currentTarget);
      } else {
        isHasLinkHandle(this.currentlinkparam, val);
      }
    },
    getLastClickMarker(markerId) {
      return getlastclickmarker(this.map, markerId);
    },
    mapinfopoint() {
      isHasLinkHandle(this.currentlinkparam, this.currendata);
    },
    itemnavigation(val) {
      navigationUrl(val);
    },
    onresize() {
      let that = this;
      window.onresize = () => {
        return (() => {
          that.isMobile = document.body.clientWidth < 768;
          that.currentSwitch = !that.isMobile;
        })();
      };
    },
    // 初始化百度地图
    getAMap(tabsdata) {
      BMapLoader().then(BMap => {
        this.map = new BMap.Map('map', {
          enableMapClick: false
        });
        let geolocation = new BMap.Geolocation();
        geolocation.getCurrentPosition(a => {
          this.point = new BMap.Point(a.point.lng, a.point.lat);
          // this.map.centerAndZoom(this.point, 15)
        });
        this.map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
        // 添加中心点和缩放等级，如果不添加，初始化出来页面为白屏
        //   this.getTabsData()
        this.defaultsearchparams(tabsdata);
      });
    },
    handleClick(val) {
      let index = parseInt(val.index);
      this.activeIndex = index;
      this.activeName = this.tabsData[index].title;
      let selectcondition = '[]';
      if (this.tabsData[index].selectcondition !== undefined && this.tabsData[index].selectcondition !== '[]') {
        selectcondition = JSON.parse(this.tabsData[index].selectcondition);
        // console.log(selectcondition)
        let confilters = [];
        selectcondition.forEach(items => {
          if (items.compt === 'selectbox' || items.compt === 'radiobutton') {
            items.val = [items.val];
          }
          confilters.push([items]);
        });
        this.condition.filters = confilters;
      }
      this.dataparams.searchStr = selectcondition !== '[]' ? encodeURI(JSON.stringify(this.condition)) : '';
      this.defaultsearchparams(this.tabsData[index]);
    },
    /* 切换地图模式or列表模式 */
    switchtype() {
      /* 初始判断 解决 点击地图默认当前类型列表 */
      if (!this.currentSwitch && this.initialswitch) {
        this.initialswitch = false;
        let obj = {
          "name": this.activeName,
          index: this.activeIndex
        };
        this.handleClick(obj);
      }
      this.currentSwitch = !this.currentSwitch;
    },
    getConfig() {}
  }
};